import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/common.service';
import { update_cms_pages } from '../../../api/apiHandler';
import { uploadImageOnAWS } from '../../aws/Service';
import Loader from '../../../utils/Loader';

const Video = Quill.import('formats/video');

class CustomVideoBlot extends Video {
    static create(value) {
        if (value && value.match(/\.(mp4|webm|ogg)$/i)) {
            let node = document.createElement('video');
            node.setAttribute('controls', true);
            node.setAttribute('src', value);
            node.setAttribute('style', 'max-width: 100%;');
            return node;
        } else {
            return super.create(value);
        }
    }
}

CustomVideoBlot.blotName = 'video';
CustomVideoBlot.tagName = ['IFRAME', 'VIDEO'];
Quill.register(CustomVideoBlot, true);

const S3_BASE_URL = 'https://studentscholars.s3.amazonaws.com/';

function Ckeditor({ data }) {
    const [pageData, setPageData] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const quillRef = useRef(null);
    const videoInputRef = useRef(null);

    useEffect(() => {
        setPageData(data.content || '');
    }, [data.content]);

    const handleVideoUpload = useCallback(async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);

        try {
            const fileName = await uploadImageOnAWS(file, 'cms_videos');
            const videoUrl = `${S3_BASE_URL}cms_videos/${fileName}`;

            const quill = quillRef.current?.getEditor();
            if (quill) {
                const range = quill.getSelection(true);
                quill.insertEmbed(range.index, 'video', videoUrl);
                quill.setSelection(range.index + 1);
            }
            TOAST_SUCCESS('Video uploaded successfully');
        } catch (error) {
            TOAST_ERROR('Video upload failed');
        } finally {
            setIsUploading(false);
        }
        e.target.value = '';
    }, []);

    const videoHandler = useCallback(() => {
        videoInputRef.current?.click();
    }, []);

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image", "video"],
                ["clean"],
            ],
            handlers: {
                video: videoHandler,
            },
        },
    }), [videoHandler]);

    const formats = [
        "header", "bold", "italic", "underline", "strike",
        "list", "bullet", "link", "image", "video",
    ];

    const submitBtn = () => {
        const obj = {
            keyword: data.keyword,
            content: pageData,
        };
        update_cms_pages(obj).then(response => {
            if (response.code == 1) {
                TOAST_SUCCESS(response.message);
            } else {
                TOAST_ERROR(response.message);
            }
        });
    };

    return (
        <div>
            <Loader isActive={isUploading} />
            <input
                type="file"
                accept="video/mp4,video/webm,video/ogg"
                ref={videoInputRef}
                style={{ display: 'none' }}
                onChange={handleVideoUpload}
            />
            <ReactQuill
                ref={quillRef}
                value={pageData}
                onChange={setPageData}
                modules={modules}
                formats={formats}
                theme="snow"
                placeholder="Write something..."
            />
            <div className="d-flex justify-content-end mt-3">
                <button
                    type="submit"
                    className="btn-theme bg-yellow mb-xl-0 mb-3 d-inline-block"
                    onClick={submitBtn}
                >
                    Submit
                </button>
            </div>
        </div>
    );
}

export default Ckeditor;
